module.exports = __webpack_public_path__ + "img/but_login_test_c.56df6414.png";